import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    suppliers_groups: [],
    suppliers_group: {},
    new_suppliers_group: {},
  },
  actions,
  mutations,
  getters,
};
